import React from "react";
import RadioButtonMega from "./_components/RadioButtonMega";

export default function RadioButtonsMega({groupName, name, options, fieldName, onChange, value, classes = null }) {

  const radioButtons = options?.map((option, index) => (
    <RadioButtonMega
      key={`RadioButtonMega${groupName}_${index}`}
      id={index}
      groupName={groupName}
      name={name}
      option={option}
      onChange={e => {
        onChange(e.target.value);
      }}
      value={value}
    />
  ));

  return (
    <div className={"gc__mega-radio-container " + classes} >
      {radioButtons}
    </div>
  );
};
